import api from './api';

const artworkService = {
    getMyArtworks: async (page = 1, limit = 12) => {
        const response = await api.get(`/artworks/my?page=${page}&limit=${limit}`);
        return response.data;
    },

    getArtworkById: async (id) => {
        const response = await api.get(`/artworks/${id}`);
        return response.data;
    }
};

export default artworkService;
